export default "__VITE_ASSET__OGArJyXe__"